import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Login from './pages/Login';
import PackingKiosk from './pages/PackingKiosk';
import { isConnected } from './services/api';
import { LicenseProvider } from './contexts/LicenseContext';
import { CartProvider } from './shop/CartContext';
import ShopLayout from './shop/ShopLayout';
import ShopHome from './shop/ShopHome';
import ShopProduct from './shop/ShopProduct';
import ShopCart from './shop/ShopCart';
import ShopCheckout from './shop/ShopCheckout';
import Dashboard from './pages/Dashboard';
import Orders from './pages/Orders';
import OrderDetail from './pages/OrderDetail';
import NewOrder from './pages/NewOrder';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Warehouse from './pages/Warehouse';
import Packing from './pages/Packing';
import Shipping from './pages/Shipping';
import Invoices from './pages/Invoices';
import Payments from './pages/Payments';
import FacebookPublish from './pages/FacebookPublish';
import Reports from './pages/Reports';
import Settings from './pages/Settings';
import Customers from './pages/Customers';
import Eshop from './pages/Eshop';

export default function App() {
  const [connected, setConnected] = useState(isConnected());

  return (
    <BrowserRouter>
      <Routes>
        {/* Veřejný eshop — bez auth */}
        <Route path="/shop" element={<CartProvider><ShopLayout /></CartProvider>}>
          <Route index element={<ShopHome />} />
          <Route path="kosik" element={<ShopCart />} />
          <Route path="objednat" element={<ShopCheckout />} />
          <Route path=":slug" element={<ShopProduct />} />
        </Route>

        {/* Standalone kiosk — no sidebar, PIN protected */}
        <Route path="/balirna" element={<PackingKiosk />} />

        {/* Login */}
        <Route path="/login" element={
          connected ? <Navigate to="/dashboard" replace /> : <Login onLogin={() => setConnected(true)} />
        } />

        <Route path="/" element={connected ? <LicenseProvider><Layout /></LicenseProvider> : <Navigate to="/login" replace />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="orders" element={<Orders />} />
          <Route path="orders/new" element={<NewOrder />} />
          <Route path="orders/:id" element={<OrderDetail />} />
          <Route path="products" element={<Products />} />
          <Route path="products/:id" element={<ProductDetail />} />
          <Route path="warehouse" element={<Warehouse />} />
          <Route path="packing" element={<Packing />} />
          <Route path="shipping" element={<Shipping />} />
          <Route path="invoices" element={<Invoices />} />
          <Route path="payments" element={<Payments />} />
          <Route path="facebook" element={<FacebookPublish />} />
          <Route path="reports" element={<Reports />} />
          <Route path="customers" element={<Customers />} />
          <Route path="eshop" element={<Eshop />} />
          <Route path="settings" element={<Settings />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
